import PropTypes from "prop-types";
import React from "react";
import NavigationContainer from "containers/Navigation";
import styles from "./NavigationWrapper.css";

export default function NavigationWrapper(props) {
  return (
    <div className={styles.root} style={props.style}>
      <NavigationContainer {...props} />
    </div>
  );
}

NavigationWrapper.propTypes = {
  style: PropTypes.object,
};
